import { DtoDocsPutRes } from "./abst/DtoDocsPutRes";

export class DtoDocsPutResImple extends DtoDocsPutRes {
  public url: string | null = null;
}
